function escapeHTML(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function identityTemplate(name) {
  var who = name ? "<p class=\"who\">".concat(escapeHTML(name), "</p>") : '';
  return "\n    <form class=\"saitosign-identity\">\n      <p class=\"title\">Is this you?</p>\n      ".concat(who, "\n      <div class=\"actions\">\n        <button type=\"button\" data-identity=\"no\">No</button>\n        <button type=\"button\" class=\"primary\" data-identity=\"yes\">Yes</button>\n      </div>\n    </form>\n  ");
}
module.exports = identityTemplate;